import React, { lazy } from 'react';
import { DollarSignIcon, HomeIcon } from 'lucide-react';
export function ComparisonSection() {
  return <section className="py-12 border-b border-gray-200" data-id="element-159">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-160">
        In-office treatment vs Oculis-3
      </h2>
      <p className="text-lg text-gray-700 mb-3 max-w-3xl" data-id="element-161">
        For years, specialists have relied on in-office devices like LipiFlow®.
        <br data-id="element-162" />
        <br data-id="element-163" />
        They apply controlled heat and gentle pressure to soften and move the natural oils that keep eyes comfortable.
        <br data-id="element-164" />
        <br data-id="element-165" />
        The temporary results can feel incredible but they come at a cost:
      </p>
      <div className="flex flex-col md:flex-row gap-8" data-id="element-166">
        <div className="md:w-1/2 bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-167">
          <div className="flex items-center mb-4" data-id="element-168">
            <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mr-4" data-id="element-169">
              <DollarSignIcon className="w-6 h-6 text-red-500" data-id="element-170" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900" data-id="element-171">
              In-Office Treatment
            </h3>
          </div>
          <ul className="space-y-3 mb-6" data-id="element-172">
            <li className="flex" data-id="element-173">
              <div className="text-red-500 mr-2" data-id="element-174">•</div>
              <p className="text-gray-700" data-id="element-175">
                <span className="font-medium" data-id="element-176">$800-$1600</span> per treatment
                session
              </p>
            </li>
            <li className="flex" data-id="element-177">
              <div className="text-red-500 mr-2" data-id="element-178">•</div>
              <p className="text-gray-700" data-id="element-179">
                Requires{' '}
                <span className="font-medium" data-id="element-180">multiple office visits</span>
              </p>
            </li>
            <li className="flex" data-id="element-181">
              <div className="text-red-500 mr-2" data-id="element-182">•</div>
              <p className="text-gray-700" data-id="element-183">
                Often{' '}
                <span className="font-medium" data-id="element-184">not covered by insurance</span>
              </p>
            </li>
            <li className="flex" data-id="element-185">
              <div className="text-red-500 mr-2" data-id="element-186">•</div>
              <p className="text-gray-700" data-id="element-187">
                Temporary relief requiring{' '}
                <span className="font-medium" data-id="element-188">repeat treatments</span>
              </p>
            </li>
            <li className="flex" data-id="element-189">
              <div className="text-red-500 mr-2" data-id="element-190">•</div>
              <p className="text-gray-700" data-id="element-191">
                Time away from work for appointments
              </p>
            </li>
            <li className="flex" data-id="element-192">
              <div className="text-red-500 mr-2" data-id="element-193">•</div>
              <p className="text-gray-700" data-id="element-194">
                Total annual cost:{' '}
                <span className="font-medium" data-id="element-195">$3,200-$6,400</span>
              </p>
            </li>
          </ul>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ibFuPPQXcNB3dFZE21gC8v/imgi_42_gempages_581238827771757064-b43d417c-5a43-4905-89ba-bf088b3c4e71.webp" alt="Patient undergoing Lipiflow clinical treatment in a doctor's office" className="rounded-lg w-full h-auto shadow-sm" width="600" height="400" loading="lazy" data-id="element-196" />
        </div>
        <div className="md:w-1/2 bg-white p-6 rounded-lg border border-teal-200 shadow-sm" data-id="element-197">
          <div className="flex items-center mb-4" data-id="element-198">
            <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center mr-4" data-id="element-199">
              <HomeIcon className="w-6 h-6 text-teal-500" data-id="element-200" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900" data-id="element-201">
              Oculis 3 At-Home Device
            </h3>
          </div>
          <ul className="space-y-3 mb-6" data-id="element-202">
            <li className="flex" data-id="element-203">
              <div className="text-teal-500 mr-2" data-id="element-204">•</div>
              <p className="text-gray-700" data-id="element-205">
                <span className="font-medium" data-id="element-206">One-time purchase</span> of{' '}
                <span className="line-through" data-id="element-207">$149.99</span>{' '}
                <span className="font-medium" data-id="element-208">$94.99</span>
              </p>
            </li>
            <li className="flex" data-id="element-209">
              <div className="text-teal-500 mr-2" data-id="element-210">•</div>
              <p className="text-gray-700" data-id="element-211">
                Use{' '}
                <span className="font-medium" data-id="element-212">
                  daily in the comfort of your home
                </span>
              </p>
            </li>
            <li className="flex" data-id="element-213">
              <div className="text-teal-500 mr-2" data-id="element-214">•</div>
              <p className="text-gray-700" data-id="element-215">
                Many FSA/HSA accounts{' '}
                <span className="font-medium" data-id="element-216">cover the cost</span>
              </p>
            </li>
            <li className="flex" data-id="element-217">
              <div className="text-teal-500 mr-2" data-id="element-218">•</div>
              <p className="text-gray-700" data-id="element-219">
                <span className="font-medium" data-id="element-220">Ongoing treatment</span> without
                additional costs
              </p>
            </li>
            <li className="flex" data-id="element-221">
              <div className="text-teal-500 mr-2" data-id="element-222">•</div>
              <p className="text-gray-700" data-id="element-223">Use while listening to podcasts or meditating</p>
            </li>
            <li className="flex" data-id="element-224">
              <div className="text-teal-500 mr-2" data-id="element-225">•</div>
              <p className="text-gray-700" data-id="element-226">
                Total annual cost: <span className="font-medium" data-id="element-227">$0</span> after
                initial purchase
              </p>
            </li>
            {/* Grey Box for Key Benefit */}
          <div className="bg-gray-100 p-4 rounded-lg text-gray-800 mb-6" data-id="element-228">
  <p data-id="element-229">
    <span className="font-semibold text-teal-600" data-id="element-230">Oculis-3</span> was designed to capture the same core benefit 
    using consistent therapeutic <span className="font-semibold" data-id="element-231">42°C heat</span> + gentle acupressure 
    but in a simple 15-minute ritual you can do at home.
  </p>
          </div>
          </ul>
          <div className="grid grid-cols-2 gap-4" data-id="element-232">
            <a href="https://irelief.us/products/vibration-bluetooth-eye-massager-visual-eye-massage-intelligent-eye-mask-massage-masajeador-heating-eyemask-face-facial-massager" className="h-full" data-id="element-233">
              <div className="h-full" data-id="element-234">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9nnBkgD3xxAwQvZjBJpTwN/Gemini_Generated_Image_pzxzompzxzompzxz.webp" alt="Woman wearing Oculis 3 device with text showing 104-113°F constant temperature hot compress and diagram illustrating same temperature range as Lipiflow treatment" className="rounded-lg w-full h-full object-cover cursor-pointer shadow-sm" width="750" height="500" loading="lazy" onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = 'https://placehold.co/600x400/e2e8f0/64748b?text=Oculis+3+Device';
              }} data-id="element-235" />
              </div>
            </a>
            <a href="https://irelief.us/products/vibration-bluetooth-eye-massager-visual-eye-massage-intelligent-eye-mask-massage-masajeador-heating-eyemask-face-facial-massager" className="h-full" data-id="element-236">
              <div className="h-full" data-id="element-237">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hfGsvgNpVxVLUYBEyPmFUE/imgi_6_imgi_85_711Xha8JqbL._AC_SL1500_ab464591-5e30-4280-9f98-76cdeacd02ac.webp" alt="Woman wearing Oculis 3 device showing kneading and compression massage techniques for comfortable eye therapy" className="rounded-lg w-full h-full object-cover cursor-pointer shadow-sm" width="750" height="500" loading="lazy" onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = 'https://placehold.co/600x400/e2e8f0/64748b?text=Oculis+3+In+Use';
              }} data-id="element-238" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>;
}